import { Injectable } from '@angular/core';
import { PontoFisico } from '../comum/modelos/ponto-fisico';
import { SettingsService } from '../settings.service';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnderecoPontoFisico } from '../comum/modelos/endereco-ponto-fisico';
import { TipoPontoFisico } from '../comum/modelos/tipo-ponto-fisico';
import { SetorCliente } from '../comum/modelos/setor-cliente';
import { ProcessoCliente } from '../comum/modelos/processo-cliente';

@Injectable()
export class PontoFisicoService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/pontos-fisicos/';
  }

  obterPontosFisicoClienteHttp(id: number): Observable<PontoFisico[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  cadastrarPontoFisicoHttp(pontoFisico: PontoFisico, foto: File): Observable<HttpResponse<PontoFisico>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', foto);
    formdata.append('pontoFisico', new Blob([JSON.stringify(pontoFisico)], {
      type: 'application/json'
    }));
    return this._http
      .post(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarPontoFisicoHttp(pontoFisico: PontoFisico, foto: File): Observable<HttpResponse<PontoFisico>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', foto);
    formdata.append('pontoFisico', new Blob([JSON.stringify(pontoFisico)], {
      type: 'application/json'
    }));
    return this._http
      .put(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerPontoFisicoHttp(idPontoFisico: number): Observable<HttpResponse<PontoFisico>> {
    return this._http.delete(this._host + idPontoFisico, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  obterPontoFisicoPorIdHttp(id: number): Observable<PontoFisico> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  inserirEnderecoPontoFisicoHttp(enderecoPontoFisico: EnderecoPontoFisico): Observable<HttpResponse<EnderecoPontoFisico>> {
    return this._http
      .post(this._host + 'endereco-ponto-fisico/', enderecoPontoFisico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarEnderecoPontoFisicoHttp(enderecoPontoFisico: EnderecoPontoFisico): Observable<HttpResponse<EnderecoPontoFisico>> {
    return this._http
      .put(this._host + 'endereco-ponto-fisico/', enderecoPontoFisico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerEnderecoPontoFisicoHttp(enderecoPontoFisico: EnderecoPontoFisico): Observable<HttpResponse<EnderecoPontoFisico>> {
    return this._http
      .patch(this._host + 'endereco-ponto-fisico/', enderecoPontoFisico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterTiposPontosFisicoHttp(id: number): Observable<TipoPontoFisico[]> {
    return this._http.get(this._host + 'tipo-ponto-fisico/' + id)
      .catch(this.handleError);
  }

  inserirTipoPontoFisicoHttp(tipoPontoFisico: TipoPontoFisico): Observable<HttpResponse<TipoPontoFisico>> {
    return this._http
      .post(this._host + 'tipo-ponto-fisico/', tipoPontoFisico, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterPontosFisicosSetorHttp(setorCliente: SetorCliente): Observable<HttpResponse<PontoFisico[]>> {
    return this._http.post(this._host + 'setores/', setorCliente, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterPontosFisicosProcessoHttp(processoCliente: ProcessoCliente): Observable<HttpResponse<PontoFisico[]>> {
    return this._http.post(this._host + 'processo/', processoCliente, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterPontosFisicosRegiaoHttp(regioes: number[]): Observable<PontoFisico[]> {
    return this._http.get(this._host + 'cliente/regiao/' + regioes)
      .catch(this.handleError);
  }

  obterPontosFisicosAreaHttp(idAreaCliente: number[]): Observable<PontoFisico[]> {
    return this._http.get(this._host + 'cliente/area/' + idAreaCliente)
      .catch(this.handleError);
  }

  obterPontosFisicosTipoPontoFisicoHttp(idsTipoPontoFisico: number[]): Observable<PontoFisico[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = idsTipoPontoFisico.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + idsTipoPontoFisico[i];
      } else {
        ids = ids + '&id=' + idsTipoPontoFisico[i];
      }
    }

    params.append('ids', ids.toString());

    return this._http.get(this._host + 'ponto-fisico-tipo-ponto-fisico/' + ids)
      .catch(this.handleError);
  }

  obterTiposPontosFisicoRegiaoHttp(idsRegioes: number[]): Observable<TipoPontoFisico[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = idsRegioes.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + idsRegioes[i];
      } else {
        ids = ids + '&id=' + idsRegioes[i];
      }
    }

    params.append('ids', ids.toString());

    return this._http.get(this._host + 'tipo-ponto-fisico-regiao' + ids)
      .catch(this.handleError);
  }

  obterTiposPontosFisicoAreaHttp(idsArea: number[]): Observable<TipoPontoFisico[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = idsArea.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + idsArea[i];
      } else {
        ids = ids + '&id=' + idsArea[i];
      }
    }

    params.append('ids', ids.toString());

    return this._http.get(this._host + 'tipo-ponto-fisico-area' + ids)
      .catch(this.handleError);
  }

  obterPontosFisicosTipoPontoFisicoRegiaoHttp(idsTipoPontoFisico: number[], idsRegioes: number[]): Observable<PontoFisico[]> {
    let idsTpf: string;
    let idsRg: string;

    for (let i = 0, len = idsTipoPontoFisico.length; i < len; i++) {
      if (i === 0) {
        idsTpf = '?idsTpf=' + idsTipoPontoFisico[i];
      } else {
        idsTpf = idsTpf + '&idsTpf=' + idsTipoPontoFisico[i];
      }
    }

    for (let i = 0, len = idsRegioes.length; i < len; i++) {
      if (i === 0) {
        idsRg = '&idsRg=' + idsRegioes[i];
      } else {
        idsRg = idsRg + '&idsRg=' + idsRegioes[i];
      }
    }

    return this._http.get(this._host + 'ponto-fisico-tipo-ponto-fisico-regiao' + idsTpf + idsRg)
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/ponto-fisico.service.ts